module.exports = __webpack_public_path__ + "img/908E8E_292828_454444_595757-256px.642d37a8.png";